import { ReactComponent as CloseIcon } from "../assets/close-icon-x.svg";

interface BannerProps {
  text: string;
  closeBanner: () => void;
}

const Banner = ({ text, closeBanner }: BannerProps) => (
  <div className="recoEngine__banner">
    <p>{text}</p>
    <button 
      onClick={closeBanner}
      aria-label="Close banner"
      type="button"
    >
      <CloseIcon />
    </button>
  </div>
);

export default Banner;
